function waterFlowBanner() {
  function push(data) {
    console.log('push');
    if(typeof data === "function") {
      console.log('calling');
      data();
    } else {
      console.log(data.yandex_stat_id);
      console.log(data.google_adunit_full_path);
      wfBanner(
        data.yandex_stat_id,
        data.yandex_block_id,
        data.node_id,
        data.event_name,
        data.google_adunit_full_path
      );
    }
  }

  function adxBanner(adunitPath, nodeId, actionName = 'downtop_loaded') {
    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function() {
      var sizes = [[300, 250], [336, 280], 'fluid', [250, 250], [970, 250], [728, 90], [750, 300], [320, 480]].filter(function(size) {
        return !Array.isArray(size) || size[0] <= document.body.clientWidth;
      });

      var slot = googletag.defineSlot(adunitPath, sizes, nodeId).addService(googletag.pubads());

      if (window.uncart_id && window.uncart_id !== '0.00') {
        slot.setTargeting('floor', floor);
      }

      var placeName = 'downtop';
      var convName = actionName;

      googletag.pubads().addEventListener("slotRequested", (event) => {
        if (event.slot === slot) window.api.trackEvent(placeName + '_requested');
      });

      googletag.pubads().addEventListener("slotResponseReceived", (event) => {
        if (event.slot !== slot) return;
        if(event.slot.getResponseInformation())
          window.api.trackEvent(placeName + '_filled')
        else
          window.api.trackEvent(placeName + '_empty');
      });

      googletag.pubads().addEventListener("impressionViewable", (event) => {
        if (event.slot !== slot) return;
        window.api.trackEvent(convName);
      });

      googletag.enableServices();
    });

    googletag.cmd.push(function() {
      googletag.display(nodeId);
    });
  }

  function yaBanner(statId, blockId, nodeId, actionName, callOnZero = null) {
    console.log('yabanner');
    window.yaContextCb = window.yaContextCb || [];
    window.yaContextCb.push(() => {
      Ya.Context.AdvManager.render({
        "blockId": blockId,
        "statId": statId,
        "renderTo": nodeId,
        onRender: (data) => {
          let totalTime = 0, timer = null, threshold = 0.5;
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio >= threshold) {
                timer = timer || setInterval(() => {
                  totalTime += 100;
                  if (totalTime >= 2000) {
                    window.api.trackEvent(actionName);
                    observer.disconnect();
                    clearInterval(timer);
                  }
                }, 100);
              } else {
                if(timer) {clearInterval(timer); timer = null;}
              }
            })
          }, { threshold });
          const el = document.getElementById(blockId);
          if (el) observer.observe(el);
        },
        onError: function(_data) {
          if (callOnZero) {
            callOnZero();
          }
        }
      }, function() {
        if (callOnZero) {
          callOnZero();
        }
      })
    })
  }

  function wfBanner(statId, blockId, nodeId, actionName, adunitPath) {
    yaBanner(statId, blockId, nodeId, actionName, function() {
      adxBanner(adunitPath, nodeId, actionName)
    })
  }

  return {
    push: push,
    wfBanner: wfBanner,
    adxBanner: adxBanner,
    yaBanner: yaBanner
  }
}

function initWaterFlowBanner() {
  window._wfb = window.wfb;
  window.wfb = waterFlowBanner();

  if (Array.isArray(window._wfb)) {
    window._wfb.forEach((data) => { window.wfb.push(data) });
  }
  return window.wfb;
}

if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", initWaterFlowBanner);
} else {
  initWaterFlowBanner();
}
